import { useState, useEffect, FormEvent } from "react";
import { useHistory, Link } from "react-router-dom";

import { Container, Row, Col, Modal, Form, Button, Card } from "react-bootstrap";

import api from "../../services/api";

import * as S from "./styled";

import Template from "../../template";

import { useAuth } from "../../context/auth";

interface UsuarioAuth {
  user?: any;
  token?: String;
  nivel?: String;
  nome?: String;
}

interface Material {
  category: string;
  name: string;
  description: string;
  id: number;
}

interface Materiais {
  nome: string;
  tipo: string;
  categoria: string;
  link: string;
  id: number;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
function Material(props) {
  const { id } = props.match.params;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const history = useHistory();

  const user: UsuarioAuth = useAuth();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [materiais, setMateriais] = useState<Material[]>([]);

  const [name, setName] = useState("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [content, setContent] = useState("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [description, setDescription] = useState("");

  const [category, setCategory] = useState("");
  const [link, setLink] = useState("");

  const [videos, setVideos] = useState<Materiais[]>([]);
  const [noticias, setNoticias] = useState<Materiais[]>([]);
  const [arquivos, setArquivos] = useState<Materiais[]>([]);

  const [reload, setReload] = useState("");
  const [hasFile, setHasFile] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<number | null>(null);

  const [show, setShow] = useState(false);

  // estados do modal de vídeo
  const [selectedVideoUrl, setSelectedVideoUrl] = useState<string | null>(null);
  const [showVideoModal, setShowVideoModal] = useState(false);

  const handleClose = () => {
    setShow(false);
    setHasFile(false);
    setLink("");
  };
  const handleShow = () => setShow(true);

  // Função para formatar o link corretamente
  const formatLink = (link: string) => {
    // Se o link começa com '/', é um arquivo do Digital Ocean
    if (link.startsWith("/")) {
      return `https://redacoes.nyc3.digitaloceanspaces.com${link}`;
    }
    // Se o link não tem protocolo, adiciona https://
    if (!link.startsWith("http://") && !link.startsWith("https://")) {
      return `https://${link}`;
    }
    // Se já tem protocolo, retorna como está
    return link;
  };

  // verifica se o link é do YouTube
  const isYouTubeLink = (url: string) => {
    return url.includes("youtube.com/watch") || url.includes("youtu.be/");
  };

  // converte URL normal do youTube para URL de embed
  const getYouTubeEmbedUrl = (url: string) => {
    try {
      const urlObj = new URL(url);
      let videoId: string | null = null;

      // formato youtube.com/watch?v=ID
      if (urlObj.hostname.includes("youtube.com")) {
        videoId = urlObj.searchParams.get("v");
      }

      // formato youtu.be/ID
      if (!videoId && urlObj.hostname.includes("youtu.be")) {
        videoId = urlObj.pathname.replace("/", "");
      }

      if (!videoId) {
        return url; // fallback: algo estranho na URL
      }

      // embed padrão com menos “distrações”
      return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&playsinline=1`;
    } catch {
      return url;
    }
  };

  // sempre abre no modal (desktop e mobile).
  // só cai pro window.open se NÃO for youtube.
  const handleOpenVideo = (video: Materiais) => {
    const formatted = formatLink(video.link);

    if (isYouTubeLink(formatted)) {
      const embedUrl = getYouTubeEmbedUrl(formatted);
      setSelectedVideoUrl(embedUrl);
      setShowVideoModal(true);
      return;
    }

    // Caso apareça algum link não YouTube, mantém comportamento antigo.
    window.open(formatted, "_blank", "noopener,noreferrer");
  };

  const handleCloseVideoModal = () => {
    setShowVideoModal(false);
    setSelectedVideoUrl(null);
  };

  async function handleAddConteudo(e: FormEvent) {
    e.preventDefault();

    const dataMaterial = {
      nome: name,
      categoria: category,
      link: link,
      material_id: id,
    };

    let response = await api.post("/materialAdd", dataMaterial);

    handleClose();

    setName("");
    setCategory("");
    setDescription("");
    setLink("");
    setHasFile(false);

    setReload(response.data);
  }

  function handleDeleteClick(e) {
    const { id } = e.target.dataset;
    setItemToDelete(Number(id));
    setShowDeleteModal(true);
  }

  async function confirmDelete() {
    if (itemToDelete) {
      let response = await api.delete(`/materialDelete/${itemToDelete}`);
      setReload(response.data);
      setShowDeleteModal(false);
      setItemToDelete(null);
    }
  }

  function cancelDelete() {
    setShowDeleteModal(false);
    setItemToDelete(null);
  }

  async function sendFile(e) {
    const data = new FormData();

    data.append("id", id);

    if (e.target.files[0]) {
      data.append("arquivo", e.target.files[0]);
      setHasFile(true);
    } else {
      setHasFile(false);
    }

    if (e.target.files[0]) {
      const response = await api.post("arquivoUpload", data);
      setLink(`/${response.data.arquivo}`);
    }
  }

  useEffect(() => {
    async function getVideos() {
      try {
        let response = await api.get(`/materialGet/${id}/video`);

        setVideos(response.data);
      } catch (err) {
      } finally {
        return false;
      }
    }

    async function getNoticias() {
      try {
        let response = await api.get(`/materialGet/${id}/noticia`);

        setNoticias(response.data);
      } catch (err) {
      } finally {
        return false;
      }
    }

    async function getArquivos() {
      try {
        let response = await api.get(`/materialGet/${id}/arquivo`);

        setArquivos(response.data);
      } catch (err) {
      } finally {
        return false;
      }
    }

    getArquivos();
    getVideos();
    getNoticias();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  return (
    <Template>
      <S.MainWrapper>
        <Container fluid style={{ maxWidth: "95%" }}>
          <Row>
            <Col sm={12}>
              <S.MainContent>
                <strong>Bem vindo ao material de apoio</strong>
                <Link
                  to="/materiais"
                  className="pull-right btn btn-success"
                >
                  Voltar aos Materiais
                </Link>
              </S.MainContent>
              {user.user.nivel === "a" && (
                <S.MainContent>
                  <strong>Administração</strong>
                  <Button
                    className="pull-right"
                    variant="success"
                    size="sm"
                    onClick={handleShow}
                  >
                    Adicionar Conteúdo
                  </Button>

                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Adicionar Conteúdo</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <Form.Label>Nome do conteúdo</Form.Label>
                        <Form.Control
                          placeholder="Nome do conteúdo"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                        <hr />
                        <Form.Group controlId="exampleForm.SelectCustom">
                          <Form.Label>Tipo de Conteúdo</Form.Label>
                          <Form.Control
                            defaultValue={category}
                            as="select"
                            custom
                            onChange={(e) => setCategory(e.target.value)}
                          >
                            <option value="video">
                              Selecione o tipo do Conteúdo
                            </option>
                            <option value="video">Vídeo</option>
                            <option value="noticia">Notícia</option>
                            <option value="arquivo">Arquivo</option>
                          </Form.Control>
                        </Form.Group>
                        <hr />
                        {!hasFile && (
                          <>
                            <Form.Label>Link do conteúdo</Form.Label>
                            <Form.Control
                              placeholder="Link do conteúdo"
                              value={link}
                              onChange={(e) => setLink(e.target.value)}
                            />
                            <hr />
                          </>
                        )}
                        <Form.Label>Arquivo</Form.Label>
                        <Form.File name="arquivo" onChange={sendFile} />
                      </Form>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose}>
                        Cancelar
                      </Button>
                      <Button variant="primary" onClick={handleAddConteudo}>
                        Adicionar
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </S.MainContent>
              )}

              <S.MainContent>
                <Row>
                  <Col sm={4}>
                    <h5
                      style={{
                        marginBottom: "20px",
                        color: "#495057",
                        fontWeight: "600",
                      }}
                    >
                      Vídeos
                    </h5>
                    <Row>
                      {videos &&
                        videos.map((video, idx) => (
                          <Col
                            key={idx}
                            sm={12}
                            style={{ marginBottom: "15px" }}
                          >
                            <S.MaterialCard>
                              <S.MaterialHeader>
                                <S.MaterialIcon>
                                  <S.VideoIcon />
                                </S.MaterialIcon>
                                <S.MaterialBadge className="video">
                                  VÍDEO
                                </S.MaterialBadge>
                                {/* título visível no card, mas não link */}
                                <S.MaterialTitle>{video.nome}</S.MaterialTitle>
                              </S.MaterialHeader>
                              <S.MaterialContent>
                                <S.MaterialActions>
                                  <S.MaterialButton
                                    variant="primary"
                                    onClick={() => handleOpenVideo(video)}
                                  >
                                    <S.VideoIcon
                                      style={{
                                        marginRight: "8px",
                                        height: "16px",
                                        width: "16px",
                                      }}
                                    />
                                    Assistir Vídeo
                                  </S.MaterialButton>
                                  {user.user.nivel === "a" && (
                                    <S.MaterialButton
                                      variant="danger"
                                      onClick={handleDeleteClick}
                                      data-id={video.id}
                                    >
                                      🗑️ Deletar
                                    </S.MaterialButton>
                                  )}
                                </S.MaterialActions>
                              </S.MaterialContent>
                            </S.MaterialCard>
                          </Col>
                        ))}
                    </Row>
                  </Col>
                  <Col sm={4}>
                    <h5
                      style={{
                        marginBottom: "20px",
                        color: "#495057",
                        fontWeight: "600",
                      }}
                    >
                      Notícias
                    </h5>
                    <Row>
                      {noticias &&
                        noticias.map((noticia, idx) => (
                          <Col
                            key={idx}
                            sm={12}
                            style={{ marginBottom: "15px" }}
                          >
                            <S.MaterialCard>
                              <S.MaterialHeader>
                                <S.MaterialIcon>
                                  <S.FileTextIcon />
                                </S.MaterialIcon>
                                <S.MaterialBadge className="noticia">
                                  NOTÍCIA
                                </S.MaterialBadge>
                                <S.MaterialTitle>{noticia.nome}</S.MaterialTitle>
                              </S.MaterialHeader>
                              <S.MaterialContent>
                                <S.MaterialActions>
                                  <a
                                    href={formatLink(noticia.link)}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                      textDecoration: "none",
                                      width: "100%",
                                    }}
                                  >
                                    <S.MaterialButton variant="primary">
                                      <S.FileTextIcon
                                        style={{
                                          marginRight: "8px",
                                          height: "16px",
                                          width: "16px",
                                        }}
                                      />
                                      Ler Notícia
                                    </S.MaterialButton>
                                  </a>
                                  {user.user.nivel === "a" && (
                                    <S.MaterialButton
                                      variant="danger"
                                      onClick={handleDeleteClick}
                                      data-id={noticia.id}
                                    >
                                      🗑️ Deletar
                                    </S.MaterialButton>
                                  )}
                                </S.MaterialActions>
                              </S.MaterialContent>
                            </S.MaterialCard>
                          </Col>
                        ))}
                    </Row>
                  </Col>
                  <Col sm={4}>
                    <h5
                      style={{
                        marginBottom: "20px",
                        color: "#495057",
                        fontWeight: "600",
                      }}
                    >
                      Arquivos
                    </h5>
                    <Row>
                      {arquivos &&
                        arquivos.map((arquivo, idx) => (
                          <Col
                            key={idx}
                            sm={12}
                            style={{ marginBottom: "15px" }}
                          >
                            <S.MaterialCard>
                              <S.MaterialHeader>
                                <S.MaterialIcon>
                                  <S.BookOpenIcon />
                                </S.MaterialIcon>
                                <S.MaterialBadge className="arquivo">
                                  ARQUIVO
                                </S.MaterialBadge>
                                <S.MaterialTitle>{arquivo.nome}</S.MaterialTitle>
                              </S.MaterialHeader>
                              <S.MaterialContent>
                                <S.MaterialActions>
                                  <a
                                    rel="noreferrer"
                                    target="_blank"
                                    href={formatLink(arquivo.link)}
                                    style={{
                                      textDecoration: "none",
                                      width: "100%",
                                    }}
                                  >
                                    <S.MaterialButton variant="primary">
                                      <S.DownloadIcon />
                                      Download Arquivo
                                    </S.MaterialButton>
                                  </a>
                                  {user.user.nivel === "a" && (
                                    <S.MaterialButton
                                      variant="danger"
                                      onClick={handleDeleteClick}
                                      data-id={arquivo.id}
                                    >
                                      🗑️ Deletar
                                    </S.MaterialButton>
                                  )}
                                </S.MaterialActions>
                              </S.MaterialContent>
                            </S.MaterialCard>
                          </Col>
                        ))}
                    </Row>
                  </Col>
                </Row>
              </S.MainContent>
            </Col>
          </Row>
        </Container>
      </S.MainWrapper>

      {/* modal para assistir vídeo do youTube (desktop e mobile) */}
      <Modal
        show={showVideoModal}
        onHide={handleCloseVideoModal}
        size="lg"
        centered
        dialogClassName="video-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Assistir Vídeo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedVideoUrl && (
            <S.VideoWrapper>
              <iframe
                src={selectedVideoUrl}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </S.VideoWrapper>
          )}
        </Modal.Body>
      </Modal>

      {/* Modal de confirmação de exclusão */}
      <Modal show={showDeleteModal} onHide={cancelDelete} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Tem certeza que deseja deletar este item? Esta ação não pode ser
          desfeita.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDelete}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Deletar
          </Button>
        </Modal.Footer>
      </Modal>
    </Template>
  );
}

export default Material;